import React from "react";
import { Popover } from "antd"; // or wherever it’s from
import matterFilled from "../../assets/images/matterFilled.svg";
import matterOutlined from "../../assets/images/matterOutlined.svg";
import { TabLabel, TabName, TabNameContainer } from "./TabViewStyled";
import MatterDetailsPopup from "../MatterDetailsPopup/MatterDetailsPopup";
import PropTypes from "prop-types";

const MatterDetailsTab = ({ tab, activeTab, matterDetails, matterDetailsTree }) => {
  const isActive = activeTab === tab.id;
  const matterInfo = {
    ...matterDetails,
    ...matterDetailsTree,
  };
  const displayName =
    matterInfo.display_name || matterInfo.matter_displayName || tab.title || "";

  return (
    <Popover placement="bottomLeft" content={<MatterDetailsPopup matterDetails={matterInfo} />}>
      <TabLabel tabactive={isActive ? "true" : ""}>
        <TabNameContainer>
          <img src={isActive ? matterFilled : matterOutlined} alt="matter icon" />
          <TabName>{displayName}</TabName>
        </TabNameContainer>
      </TabLabel>
    </Popover>
  );
};

MatterDetailsTab.propTypes = {
  tab: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
  }).isRequired,
  activeTab: PropTypes.string.isRequired,
  matterDetails: PropTypes.object.isRequired, // can refine if you know the structure
  matterDetailsTree: PropTypes.object.isRequired,
};

export default MatterDetailsTab;
